const AUTH_TOKEN_KEY = 'token';
const AUTH_LOGIN_KEY = 'login';
const REDIRECT_KEY = 'authRedirectTarget';

function getStorage(type) {
  if (typeof window === 'undefined') return null;
  try {
    const storage = type === 'session' ? window.sessionStorage : window.localStorage;
    const probe = `__shefa_storage_probe_${type}`;
    storage.setItem(probe, '1');
    storage.removeItem(probe);
    return storage;
  } catch {
    return null;
  }
}

function readKey(key) {
  const localValue = getStorage('local')?.getItem(key);
  if (localValue) return localValue;
  return getStorage('session')?.getItem(key) || null;
}

function writeKey(key, value) {
  const normalized = String(value || '');
  let wrote = false;
  const local = getStorage('local');
  if (local) {
    local.setItem(key, normalized);
    wrote = true;
  }
  const session = getStorage('session');
  if (session) {
    session.setItem(key, normalized);
    wrote = true;
  }
  return wrote;
}

function removeKey(key) {
  getStorage('local')?.removeItem(key);
  getStorage('session')?.removeItem(key);
}

export function getStoredToken() {
  return readKey(AUTH_TOKEN_KEY);
}

export function setStoredAuth(token, login) {
  writeKey(AUTH_TOKEN_KEY, token);
  if (login) writeKey(AUTH_LOGIN_KEY, login);
}

export function clearStoredAuth() {
  removeKey(AUTH_TOKEN_KEY);
  removeKey(AUTH_LOGIN_KEY);
}

export function getStoredRedirectTarget() {
  return readKey(REDIRECT_KEY);
}

export function setStoredRedirectTarget(target) {
  if (target) writeKey(REDIRECT_KEY, target);
}

export function clearStoredRedirectTarget() {
  removeKey(REDIRECT_KEY);
}
